// @flow
/** @jsx jsx */

import { Price } from '@zapier/common-components';
import { jsx } from '@emotion/core';
import { Border, Colors } from '@zapier/theme';

type AmountDueProps = {
  amountDue: number,
};

const invoiceTotalCss = {
  color: Colors.deepSpace,
  display: 'flex',
  fontWeight: 600,
  padding: 10,

  '&:not(:last-child)': {
    borderBottom: `${Border.size.default} solid ${Border.color.default}`,
  },
};

const invoiceTotalPriceCss = {
  fontSize: '1.3em',
  marginLeft: 'auto', // push the price to the right of the container
  whiteSpace: 'nowrap',
  paddingLeft: 20,
};

const AmountDue = ({ amountDue }: AmountDueProps) => {
  const isRefund = amountDue < 0;

  return (
    <div css={invoiceTotalCss}>
      {isRefund
        ? 'Credit applied to your next invoice'
        : 'Amount being charged today'}
      <span css={invoiceTotalPriceCss}>
        <Price>{Math.abs(amountDue)}</Price>
      </span>
    </div>
  );
};

export default AmountDue;
